import { DefaultTheme } from 'styled-components';

import { BodyProps } from './Body01';
import { FontColor } from './types';

export function getBodyFontWeight(props: BodyProps & { theme: DefaultTheme }) {
    if (props.bold) {
        return props.theme.fontWeightBold;
    }

    if (props.medium) {
        return props.theme.fontWeightMedium;
    }

    if (props.light) {
        return props.theme.fontWeightLight;
    }

    return props.theme.fontWeightRegular;
}

export function getTypographyFontColor({ color, theme }: { color?: FontColor, theme: DefaultTheme }) {
    switch (color) {
        case 'primary':
            return theme.semanticColor.textPrimary;
        case 'secondary':
            return theme.semanticColor.textSecondary;
        case 'tertiary':
            return theme.semanticColor.textTertiary;
        default:
            return color;
    }
}
